<template>
    <v-menu :nudge-width="100">
        <v-toolbar-title slot="activator">
          <!--<v-icon>arrow_drop_down</v-icon>-->
          <!--<span>{{menuAll}}</span>-->
          <v-icon>menu</v-icon>
        </v-toolbar-title>

        <v-list>
          <v-list-tile
            @click="goHome()"
          >
            <v-list-tile-title v-text="homeNavTitle"></v-list-tile-title>
          </v-list-tile>
        </v-list>
        <v-list>
          <v-list-tile
            @click="goPrivateData()"
          >
            <v-list-tile-title v-text="privateDataPolicyNavTitle"></v-list-tile-title>
          </v-list-tile>
        </v-list>
        <v-list>
          <v-list-tile
            @click="goImprint()"
          >
            <v-list-tile-title v-text="imprintNavTitle"></v-list-tile-title>
          </v-list-tile>
        </v-list>
        <v-list>
          <v-list-tile
            @click="goContact()"
          >
            <v-list-tile-title v-text="contactNavTitle"></v-list-tile-title>
          </v-list-tile>
        </v-list>
    </v-menu>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState('ContactModule', [ 
                                        'homeNavTitle',
                                        'privateDataPolicyNavTitle',
                                        'imprintNavTitle',
                                        'contactNavTitle',
                                        'menuAll',
                                        ]),
    },
    methods: {
        goHome(){
            this.$router.push('home');
        },
        goPrivateData(){
            this.$router.push('policy');
        },
        goImprint(){
            this.$router.push('imprint');
        },
        goContact(){
            this.$router.push('contact');
        },
    }
}
</script>

